import type { Command, CommandContext } from './types';

class CommandRegistryImpl {
  private commands = new Map<string, Command>();

  register(command: Command): void {
    this.commands.set(command.id, command);
  }

  registerAll(commands: Command[]): void {
    for (const cmd of commands) {
      this.register(cmd);
    }
  }

  execute(commandId: string, ctx: CommandContext): boolean {
    const command = this.commands.get(commandId);
    if (!command) {
      console.warn(`Command not found: ${commandId}`);
      return false;
    }
    if (command.canExecute && !command.canExecute(ctx)) {
      return false;
    }
    command.execute(ctx);
    return true;
  }

  get(commandId: string): Command | undefined {
    return this.commands.get(commandId);
  }

  getAll(): Command[] {
    return Array.from(this.commands.values());
  }

  getByCategory(category: Command['category']): Command[] {
    return this.getAll().filter((cmd) => cmd.category === category);
  }
}

export const commandRegistry = new CommandRegistryImpl();
